import { PlanPriceProps } from '../../types/pricing.types';

export const PlanPrice = ({ price, finalPrice, priceForYear, period }: PlanPriceProps) => {
  let billingNote = 'Billed monthly';
  if (finalPrice !== price) {
    billingNote = `Base: $${price.toFixed(0)}/mo`;
  } else if (period === 'year' && priceForYear !== 0) {
    billingNote = `$${priceForYear} billed annually`;
  }

  return (
    <div>
      <p className='flex items-baseline gap-[7px] text-white'>
        <strong className='text-4xl font-semibold leading-none'>${finalPrice.toFixed(0)}</strong>
        <span className='text-lg text-ob-text-subtle'>/mo</span>
      </p>
      <p className='mt-2.5 min-h-5 text-sm text-ob-text-muted'>{billingNote}</p>
    </div>
  );
};
